import React from 'react';
import './Divider.css';

interface DividerProps {
  'data-testid'?: string;
}

export const Divider: React.FC<DividerProps> = ({ 'data-testid': dataTestId }) => (
  <div className="divider" data-testid={dataTestId} />
);
